// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PolicyPage_prose-block__9Xk82 {
  max-width: 1000px;
  padding: 2rem;
  margin: auto;
  color: #333;
}
.PolicyPage_prose-block__9Xk82 ul {
  margin-left: 1rem;
}
.PolicyPage_prose-block__9Xk82 h1, .PolicyPage_prose-block__9Xk82 h2 {
  color: black;
  margin-top: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/containers/PolicyPage.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AACF;AACE;EACE,iBAAA;AACJ;AAEE;EACE,YAAA;EACA,gBAAA;AAAJ","sourcesContent":[".prose-block {\n  max-width: 1000px;\n  padding: 2rem;\n  margin: auto;\n  color: #333;\n}\n.prose-block ul {\n  margin-left: 1rem;\n}\n.prose-block h1, .prose-block h2 {\n  color: black;\n  margin-top: 2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"prose-block": `PolicyPage_prose-block__9Xk82`
};
export default ___CSS_LOADER_EXPORT___;
